<template>
  <div
    ref="kt_modal_adicional_produto"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_adicional_produto"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            <img
              src="media/icons/duotune/abstract/abs027.svg"
              class="me-2"
            />Adicionais
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="modalExibirAdicional(false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-0">
          <div
            v-if="this.produto"
            class="d-flex flex-column-fluid p-4 bg-lighten"
          >
            <div class="container-xxl p-0">
              <div class="d-flex flex-column flex-lg-row">
                <div class="d-flex flex-column gap-6 gap-lg-4 w-lg-400px">
                  <div class="card card-flush me-lg-4">
                    <div class="image-block">
                      <el-image
                        v-if="this.produto.imagem"
                        style="max-width: 400px; max-height: 250px"
                        :src="this.$utils.getUrl() + this.produto.imagem"
                        fit="cover"
                        :style="{
                          borderRadius: `6px`,
                        }"
                      />
                      <div class="align-self-center pt-4 px-6">
                        <h3 class="modal-title">
                          {{ this.produto.nome }}
                        </h3>
                        <span class="text-dark fs-7 d-block">
                          {{ this.produto.descricao }}
                        </span>
                        <span
                          v-if="this.produto.promocaoAtiva === false"
                          class="text-dark fs-6 d-block"
                        >
                          R$
                          {{ this.$utils.formatarNumero(this.produto.preco) }}
                        </span>
                        <div
                          class="d-flex align-items-center justify-content-center"
                          v-else
                        >
                          <span class="text-success fs-5 d-block">
                            R$
                            {{
                              this.$utils.formatarNumero(
                                this.produto.preco_promocao
                              )
                            }}
                          </span>
                          <span
                            class="ms-2 text-muted fs-6 fw- d-block text-riscado"
                          >
                            R$
                            {{ this.$utils.formatarNumero(this.produto.preco) }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="menu menu-rounded menu-column menu-active-bg menu-hover-bg menu-title-dark fs-5 mt-5"
                      data-kt-menu="true"
                    >
                      <div
                        class="menu-item"
                        v-for="(grupo, i) in this.produto.Adicional
                          .AdicionalGrupo"
                        v-bind:key="i"
                      >
                        <a
                          class="menu-link border-3 border-start border-info py-3 ps-3 d-flex"
                          @click="selecionarGrupo(i)"
                          :class="[grupo.id === idGrupo && 'active']"
                        >
                          <div
                            v-if="grupo.imagem ? grupo.imagem : ''"
                            class="symbol symbol-50px symbol-circle"
                          >
                            <div
                              class="symbol-label fs-2 fw-bold"
                              :style="{
                                'background-image': `url(${
                                  this.$utils.getUrl() + grupo.imagem
                                })`,
                              }"
                            ></div>
                          </div>
                          <div v-else class="symbol symbol-50px symbol-circle">
                            <div
                              :class="[
                                'symbol-label fs-2 fw-bold bg-light-info text-info',
                              ]"
                            >
                              {{
                                grupo.descricao
                                  ? grupo.descricao
                                      .substring(0, 1)
                                      .toUpperCase()
                                  : ""
                              }}
                            </div>
                          </div>
                          <div class="align-self-center ms-4">
                            <span class="menu-title fw-bold">
                              {{ grupo.descricao }}
                            </span>
                            <span
                              v-if="grupo.observacao"
                              class="text-dark fs-7 d-block"
                            >
                              {{ grupo.observacao }}
                            </span>
                          </div>

                          <div class="d-flex ms-auto align-self-start">
                            <span
                              v-if="grupo.maximo > -1"
                              class="fs-7 fw-bold text-dark pe-2 pt-1"
                              >{{
                                verificarQtdSelecionada(grupo) +
                                "/" +
                                grupo.maximo
                              }}</span
                            >
                            <span
                              v-if="grupo.obrigatorio === '1'"
                              class="badge badge-danger justify-content-center w-85px"
                              >Obrigatório</span
                            >
                            <span
                              v-else
                              class="badge badge-warning justify-content-center w-85px"
                              >Opcional</span
                            >
                          </div>
                        </a>
                      </div>
                      <div
                        v-if="
                          this.produto.Adicional.AdicionalGrupo.length === 0
                        "
                        class="d-flex align-items-center py-3 px-2 ps-lg-10 pe-lg-4 border-3 rounded border-start border-info"
                      >
                        <span class="bullet bullet-dot bg-dark"></span>
                        <span class="ps-4">Nenhum grupo foi encontrado!</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-row-fluid gap-6 mb-0 gap-lg-10"
                >
                  <div class="d-flex flex-column gap-7 gap-lg-10">
                    <div class="card card-flush pt-4">
                      <div class="d-flex flex-column align-items-center">
                        <span class="mb-4 text-dark fw-bold">Quantidade</span>
                        <el-input-number
                          :id="`Qtd`"
                          class="w-150px"
                          v-model="qtdProduto"
                          size="large"
                          :min="1"
                          v-on:keyup.enter="this.selecionarGrupo(0)"
                          @change="recalcularValores()"
                          :max="undefined"
                        />
                      </div>

                      <div
                        class="menu menu-rounded menu-column menu-active-bg menu-hover-bg menu-title-dark fs-5 mt-5"
                        data-kt-menu="true"
                      >
                        <div
                          class="menu-item"
                          v-for="(item, i) in this.grupoItem"
                          v-bind:key="i"
                        >
                          <a
                            class="menu-link border-3 border-start border-info py-1 ps-3 d-flex align-items-center"
                          >
                            <div
                              v-if="item.imagem ? item.imagem : ''"
                              class="symbol symbol-40px symbol-circle py-1"
                            >
                              <div
                                class="symbol-label fs-2 fw-bold bg-light-info"
                                :style="{
                                  'background-image': `url(${
                                    this.$utils.getUrl() + item.imagem
                                  })`,
                                }"
                              ></div>
                            </div>
                            <div
                              v-else
                              class="symbol symbol-40px symbol-circle py-1"
                            >
                              <div
                                :class="[
                                  'symbol-label fs-2 fw-bold bg-light-info text-info',
                                ]"
                              >
                                {{
                                  item.descricao
                                    ? item.descricao
                                        .substring(0, 1)
                                        .toUpperCase()
                                    : ""
                                }}
                              </div>
                            </div>
                            <div class="ms-4 align-middle">
                              <span class="menu-title fw-bold">
                                {{ item.descricao }}
                              </span>
                              <span
                                v-if="item.valor > 0"
                                class="text-dark fs-6 d-block"
                              >
                                + R$
                                {{ this.$utils.formatarNumero(item.valor) }}
                              </span>
                            </div>
                            <div class="position-absolute end-0 me-4">
                              <el-input-number
                                :id="`Item${i}`"
                                class="w-100px"
                                v-model="item.qtd"
                                size="small"
                                :min="0"
                                :max="item.max"
                                v-on:keyup.enter="
                                  verificarQtdMaxima($event.target, i)
                                "
                                @change="verificarQtdMaxima($event.target, i)"
                              />
                            </div>
                          </a>
                        </div>
                        <div
                          v-if="
                            this.grupoItem.length === 0 && this.idGrupo != 0
                          "
                          class="d-flex align-items-center py-3 px-2 ps-lg-10 pe-lg-4 border-3 rounded border-start border-info"
                        >
                          <span class="bullet bullet-dot bg-dark"></span>
                          <span class="ps-4">Nenhum item foi encontrado!</span>
                        </div>
                        <div
                          v-if="this.idGrupo === 0"
                          class="d-flex align-items-center py-3 px-2 ps-lg-10 pe-lg-4 border-3 rounded border-start border-info"
                        >
                          <span class="bullet bullet-dot bg-dark"></span>
                          <span class="ps-4"
                            >Selecione um grupo de adicional!</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column-fluid px-4 bg-lighten">
            <div class="d-flex flex-column flex-row-fluid gap-6 mb-4 gap-lg-10">
              <div class="d-flex flex-column gap-6 gap-lg-4">
                <div class="card card-flush py-4">
                  <div class="card-body pt-0 pb-0">
                    <div class="mb-0 fv-row">
                      <span class="svg-icon svg-icon-1 svg-icon-danger">
                        <inline-svg
                          src="media/icons/duotune/communication/com003.svg"
                          class="me-2"
                        />
                      </span>
                      <label class="form-label">Alguma observação?</label>
                      <textarea
                        id="txtObs"
                        class="form-control mb-2"
                        placeholder="Ex: Tirar a cebola, maionese à parte, ponto da carne, etc..."
                        maxlength="300"
                        style="height: 85px"
                        v-model="this.observacao"
                        @input="
                          this.observacao = this.observacao.replace(
                            /[\r\n]+/gm,
                            ''
                          )
                        "
                        v-on:keyup.enter="this.nextFocusId(`Adicionar`)"
                      />
                      <div class="text-end text-muted fs-7">
                        {{ this.observacao ? this.observacao.length : "0" }}/300
                        caracteres
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            id="Adicionar"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            :class="[this.enableAdicionar === false && 'disabled']"
            @click="confirmarAdicional()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/ecommerce/ecm002.svg"
                class="me-2"
              />{{
                (this.add === true ? "Adicionar R$ " : "Atualizar R$ ") +
                this.$utils.formatarNumero(this.subTotal)
              }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";

export default {
  emits: ["exibirModalAdicional", "confirmarAdicional", "update:produto"],
  components: {},
  props: {
    produto: { type: Object, required: false },
    add: { type: Boolean, required: true },
    indexEdicao: { type: Number, required: true },
  },
  methods: {
    async atualizarQtdMaxima(target, index) {
      var somaQtdGrupo = 0;
      var grupo = this.produto.Adicional.AdicionalGrupo[this.grupoSelecionado];
      for (var i = 0; i < grupo.AdicionalGrupoItem.length; i++) {
        somaQtdGrupo += grupo.AdicionalGrupoItem[i].qtd;
      }

      for (var y = 0; y < this.grupoItem.length; y++) {
        if (grupo.maximo === -1) {
          this.grupoItem[y].max = undefined;
        } else {
          this.grupoItem[y].max =
            grupo.maximo - somaQtdGrupo + this.grupoItem[y].qtd;
        }
      }
      if (somaQtdGrupo === grupo.maximo && this.add === true) {
        if (
          this.grupoSelecionado <
          this.produto.Adicional.AdicionalGrupo.length - 1
        ) {
          clearTimeout(this.timeOut);
          this.timeOut = setTimeout(this.atualizarGrupoSelecionado, 100);
        } else {
          if (target != undefined) {
            this.nextFocus(`Item${index + 1}`);
          }
        }
      } else {
        if (target != undefined) {
          this.nextFocus(`Item${index + 1}`);
        }
      }
    },
    nextFocus(id) {
      var input = document.getElementById(id);
      if (input != null) {
        input.select();
        input.focus();
      } else {
        document.getElementById("txtObs").focus();
      }
    },
    nextFocusId(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    atualizarGrupoSelecionado() {
      this.selecionarGrupo(this.grupoSelecionado + 1);
    },
    async verificarQtdMaxima(target, index) {
      var somaQtdGrupo = 0;
      var grupo = this.produto.Adicional.AdicionalGrupo[this.grupoSelecionado];
      for (var i = 0; i < grupo.AdicionalGrupoItem.length; i++) {
        somaQtdGrupo += grupo.AdicionalGrupoItem[i].qtd;
      }
      if (grupo.maximo > -1) {
        if (somaQtdGrupo > grupo.maximo) {
          somaQtdGrupo = somaQtdGrupo - this.grupoItem[index].qtd;
          this.grupoItem[index].qtd = grupo.maximo - somaQtdGrupo;
        }
      }
      await this.recalcularValores();
      await this.atualizarQtdMaxima(target, index);
    },
    verificarQtdSelecionada(grupo) {
      var qtd = 0;
      for (var i = 0; i < grupo.AdicionalGrupoItem.length; i++) {
        qtd += grupo.AdicionalGrupoItem[i].qtd;
      }
      return qtd;
    },
    recalcularValores() {
      var grupos = this.produto.Adicional.AdicionalGrupo;
      this.totalSubItens = 0;
      var validaMinimo = true;
      for (var i = 0; i < grupos.length; i++) {
        var somaItens = 0;
        for (var y = 0; y < grupos[i].AdicionalGrupoItem.length; y++) {
          this.totalSubItens +=
            grupos[i].AdicionalGrupoItem[y].qtd *
            grupos[i].AdicionalGrupoItem[y].valor;
          somaItens += grupos[i].AdicionalGrupoItem[y].qtd;
        }

        //Verifica se selecionou as quantidades obrigatórias para habilitar o botão de Adicionar
        if (somaItens < grupos[i].minimo) {
          validaMinimo = false;
        }
      }
      this.subTotal =
        ((this.produto.promocaoAtiva === false
          ? this.produto.preco
          : this.produto.preco_promocao) +
          this.totalSubItens) *
        this.qtdProduto;

      if (validaMinimo === true) {
        this.enableAdicionar = true;
      } else {
        this.enableAdicionar = false;
      }
    },
    selecionarGrupo(i) {
      var grupo = this.produto.Adicional.AdicionalGrupo[i];
      if (grupo != null) {
        this.idGrupo = grupo.id;
        this.grupoSelecionado = i;
        this.carregarGrupoItem(grupo);
      }
      this.verificarQtdMaxima(undefined, i);
    },
    carregarGrupoItem(grupo) {
      this.grupoItem = grupo.AdicionalGrupoItem;
      if (this.grupoItem != null && this.grupoItem.length > 0) {
        setTimeout(() => {
          var input = document.getElementById(`Item0`);
          input.select();
          input.focus();
        }, 100);
      }
    },
    modalExibirAdicional(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalAdicional", false);
      }
    },
    confirmarAdicional() {
      if (this.enableAdicionar === true) {
        var prod = this.produto;
        prod.observacao = this.observacao;
        prod.qtd = this.qtdProduto;
        this.$emit("confirmarAdicional", prod, this.add, this.indexEdicao);
        hideModal(this.$refs.kt_modal_adicional_produto);
      }
    },
    async carregarAdicional() {
      this.idGrupo = 0;
      this.grupoSelecionado = -1;
      this.enableAdicionar = false;
      this.grupoItem = [];
      this.qtdProduto = 0;
      this.subTotal = 0;
      this.timeOut = 0;
      this.observacao = "";
      this.totalSubItens = 0;

      var prod = this.produto;

      for (var i = 0; i < prod.Adicional.AdicionalGrupo.length; i++) {
        for (
          var y = 0;
          y < prod.Adicional.AdicionalGrupo[i].AdicionalGrupoItem.length;
          y++
        ) {
          if (
            this.add === true ||
            prod.Adicional.AdicionalGrupo[i].AdicionalGrupoItem[y].qtd ===
              undefined
          ) {
            prod.Adicional.AdicionalGrupo[i].AdicionalGrupoItem[y].qtd = 0;
          }

          prod.Adicional.AdicionalGrupo[i].AdicionalGrupoItem[y].max =
            undefined;
        }

        var grupo = prod.Adicional.AdicionalGrupo[i];
        if (grupo.minimo === 0 && grupo.maximo === 1) {
          prod.Adicional.AdicionalGrupo[i].observacao = "Escolha até 1 opção";
        }
        if (grupo.minimo === 0 && grupo.maximo === -1) {
          prod.Adicional.AdicionalGrupo[i].observacao = "Escolha mais opções";
        }
        if (grupo.minimo === 0 && grupo.maximo >= 2) {
          prod.Adicional.AdicionalGrupo[i].observacao =
            "Escolha até " + grupo.maximo + " opções";
        }

        if (grupo.minimo === 1 && grupo.maximo === 1) {
          prod.Adicional.AdicionalGrupo[i].observacao = "Escolha 1 opção";
        }
        if (grupo.minimo === 1 && grupo.maximo === -1) {
          prod.Adicional.AdicionalGrupo[i].observacao =
            "Escolha 1 ou mais opções";
        }
        if (grupo.minimo >= 1 && grupo.maximo >= 2) {
          prod.Adicional.AdicionalGrupo[i].observacao =
            "Escolha de " + grupo.minimo + " a " + grupo.maximo + " opções";
        }
      }

      if (this.add === false) {
        this.observacao = prod.observacao;
        this.qtdProduto = prod.qtd;
        this.selecionarGrupo(0);
      }

      this.$emit("update:produto", prod);
    },
  },
  async mounted() {
    await this.carregarAdicional();
    await this.recalcularValores();
    setTimeout(() => {
      var input = document.getElementById(`Qtd`);
      input.focus();
      input.select();
    }, 800);
  },
  data() {
    return {
      timeOut: 0,
      idGrupo: 0,
      grupoSelecionado: -1,
      enableAdicionar: false,
      grupoItem: [],
      qtdProduto: 0,
      observacao: "",
      subTotal: 0,
      totalSubItens: 0,
    };
  },
};
</script>

<style>
.image-block {
  padding: 0px 0;
  text-align: center;
  display: inline-block;
  width: 100%;
  vertical-align: top;
}
.text-riscado {
  text-decoration: line-through;
}
</style>
